import { ProfileOptionOriginal } from "PFApp/helpers/options/profiles_options";
import { Button } from "PFComponents/button";
import { LoadingDots } from "PFComponents/loading_dots";
import { gidFor } from "PFCore/helpers/gid";
import { isMsTeams, openChatInMsTeams } from "PFCore/helpers/ms_teams";
import { saveConversation } from "PFCore/services/chat/save_conversation";
import { saveParticipant } from "PFCore/services/chat/save_participant";
import { fetchProfile } from "PFCore/services/profile";
import { Activity, CurrentProfile, GIdTargetType } from "PFTypes";
import { ChatParticipant } from "PFTypes/chat_participant";
import { useState } from "react";
import { useTranslation } from "react-i18next";

type OpenNewChatButtonProps = {
  item: ProfileOptionOriginal;
  activity: Activity;
  participants: ChatParticipant[] | null;
  renderChat: (conversationId: number) => void;
  currentProfile: CurrentProfile;
  setParticipants?: (participants: ChatParticipant[]) => void;
  handleClose?: () => void;
};

export const OpenNewChatButton = ({
  item,
  activity,
  participants,
  renderChat,
  currentProfile
}: OpenNewChatButtonProps) => {
  const { t } = useTranslation();

  const [isPending, setIsPending] = useState(false);

  if (!participants) {
    return <LoadingDots />;
  }

  const participant = participants.find(({ profile: { id } }) => id === item.id);

  const [kind, copy, qaIdSuffix] = participant
    ? (["secondary", t("conversations.open121"), ".open"] as const)
    : isPending
      ? (["blank", <LoadingDots key="idem" />, ".pending"] as const)
      : (["primary", t("conversations.start121"), ".start"] as const);

  return (
    <Button
      qaId={`OpenNewChatButton${qaIdSuffix}`}
      small
      style={{ minWidth: 80 }}
      kind={kind}
      disabled={isPending}
      onClick={() => {
        if (isMsTeams()) {
          fetchProfile(item.id).then((profile) => openChatInMsTeams(profile?.email || ""));
          return;
        }
        if (participant) {
          renderChat(participant.conversationId);
        } else {
          setIsPending(true);
          saveConversation({
            target: gidFor(GIdTargetType.Task, activity.id),
            ownerId: currentProfile.id
          }).then((resp) => {
            renderChat(resp.id);
            saveParticipant({
              conversationId: resp.id,
              profileId: item.id
            });
          });
        }
      }}
    >
      {copy}
    </Button>
  );
};
